<div appClickedOutside (clickedOutside)="closeResults()">
    <sh-input-text
        #input id="search" [label]="label"
        [formControl]="inputControl"
        (click)="onInputInteraction()"
        (focusin)="onInputInteraction()"
        (clear-clicked)="clearSelection()"
        >
        <sh-icon *ngIf="!isLoading" icon='search' button size='s' slot='icon' (click)="onSearchClick()"></sh-icon>
        <div class="rotate" slot='icon' *ngIf="isLoading"><sh-icon icon='refresh' button size='s'></sh-icon></div>
    </sh-input-text>
    <div class="result-list" [style.width.px]="resultListWidth" *ngIf="showResults && searchArray?.length">
        <div class="result-item" [class.result-item-active]="isActive(item)" *ngFor="let item of searchArray">
            <sh-checkbox *ngIf="multiSelect" [active]="isActive(item)" class="result-item-checkbox" (click)="$event.stopPropagation()" (checked)="onSelect(item, $event)"></sh-checkbox>
            <div class="result-item-content">
                <div [innerHTML]="item.id | highlight: inputControl.value"></div>
                <div [innerHTML]="item.name | highlight: inputControl.value"></div>
            </div>
        </div>
        <div class="result-item-no-records" *ngIf="!searchArray?.length && !isLoading">
            <div>No Results Found.</div>
        </div>        
    </div>
</div>